import React, { useEffect, useState } from 'react'
import { RoomSessionKind, useStartSessionMutation } from '../../../../store/media/media'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoomSession } from '../../../../models/Room'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'

const ONE_HOUR_IN_MS = 60 * 60 * 1000

export const CreateInPersonMeetingLoader = () => {
  const accountId = useAppSelector(selectAccountId)
  const [startSession, { isSuccess }] = useStartSessionMutation()
  const [session, setSession] = useState<RoomSession | null>(null)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (isSuccess && session) {
      navigate(`/workspace/${pathname.includes('live-meetings') ? 'live-meetings' : 'upcoming'}/room/${session.roomId}/session/${session.id}`)
    }
  }, [isSuccess, navigate, pathname, session])

  useEffect(() => {
    const triggerStartSession = async () => {
      const now = new Date()
      const session = await startSession({
        accountId,
        body: {
          kind: RoomSessionKind.UPCOMING_IN_PERSON,
          startedAt: new Date(now.getTime() + ONE_HOUR_IN_MS / 2).toISOString(),
          finishedAt: new Date(now.getTime() + ONE_HOUR_IN_MS).toISOString(),
        },
      }).unwrap()
      setSession(session)
    }
    triggerStartSession().catch(console.error)
  }, [accountId, startSession])

  return (
    <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }}>
      <div className='d-flex flex-column align-items-center'>
        <div>Creating In Person meeting...</div>
        <div className='small-medium'>It may take a few seconds</div>
      </div>
    </div>
  )
}
